export default "__VITE_ASSET__CDodzq0E__"